import React, { useEffect, useRef, useState } from "react";
import { Alert } from "@mui/material";

import CourseInfoWidget from "../components/widgets/CourseInfoWidget";
import SocialShareWidget from "../components/widgets/SocialShareWidget";
import Payment from "./Payment";

import { getUserNameByGId } from "../handler/LoginAndSingupHandler";

import packagePoster from "../Common/PackagePoster.js";
import UserLoaderBlankBackground from "src/Dashboard/UserLoaderBlankBackground";
import confetti from "canvas-confetti";

import { GetCourseList } from "src/handler/coursehandler";

import courseImage from "src/Common/CourseImage";

import { ClipLoader } from "react-spinners";

import CartIcon from "../Payment/CartIcon";
import CartModal from "./CartModal";

import InternshipPurchase from "./InternshipPurchase";


const Package = () => {

    /* =========================================================
       CONFIG
    ========================================================= */

    const discountOnPackage = 20;
    const discountOnCourses = 10;


    /* =========================================================
       TEMPLATE
    ========================================================= */

    const [template, setTemplate] = useState<
        "package"
        | "packageDetail"
        | "payment"
        | "cart"
        | "internship"
    >("package");


    /* =========================================================
       GENERAL STATE
    ========================================================= */

    const [loader, setLoader] = useState(false);

    const [sponsorGrowniverseId, setSponsorGrowniverseId] =
        useState("");

    const [addNewSponsorGrowniverseId, setAddNewSponsorGrowniverseId] =
        useState("");

    const [couponCode, setCouponCode] =
        useState(false);

    const [inputCouponCode, setInputCouponCode] =
        useState("");

    const [showCouponCode, setShowCouponCode] =
        useState(false);

    const [invalidCouponCode, setInvalidCouponCode] =
        useState(false);

    const [userInformationId, setUserInformationId] =
        useState("");


    /* =========================================================
       PACKAGE / COURSE
    ========================================================= */

    const [getShowPackages, setShowPackages] =
        useState(false);

    const [searchTerm, setSearchTerm] =
        useState("");

    const [packages, setPackages] =
        useState<any[]>([]);

    const [packageDetailData, setPackageDetailPage] =
        useState<any>({
            packageId: 0,
            packageName: "",
            packageDescription: "",
            packagePrice: 12000,
            discountedPrice: 8500,
        });

    const [coursesList, setCoursesList] =
        useState<any[]>([]);

    const [checkCountCourseList, setCheckoutCoursesList] =
        useState<any[]>([]);

    const [hasMore, setHasMore] =
        useState(true);


    /* =========================================================
       REFS
    ========================================================= */

    const runOnce = useRef(false);

    const runOnceForLoad = useRef(false);

    const listloader =
        useRef<HTMLDivElement>(null);

    const skip = useRef(0);

    const take = 100;


    /* =========================================================
       LOAD USER + PACKAGES
    ========================================================= */

    useEffect(() => {

        if (runOnce.current)
            return;

        try {

            const storedProfile =
                localStorage.getItem(
                    "userProfile"
                );

            if (storedProfile) {

                const userProfile =
                    JSON.parse(
                        storedProfile
                    );

                if (
                    userProfile?.status > 3
                ) {

                    window.location.href =
                        "/dashboard";

                    return;
                }

                setUserInformationId(
                    userProfile?.userInformationId ||
                    ""
                );

                setSponsorGrowniverseId(
                    userProfile?.sponsorGrowniverseId ||
                    ""
                );
            }


            const storedPackages =
                localStorage.getItem(
                    "packages"
                );

            if (storedPackages) {

                const packagesData =
                    JSON.parse(
                        storedPackages
                    );

                if (
                    Array.isArray(
                        packagesData
                    )
                ) {

                    setPackages(
                        packagesData
                    );
                }
            }

        } catch (error) {

            console.error(
                "Unable to load package information:",
                error
            );
        }

        runOnce.current = true;

    }, []);


    /* =========================================================
       LOAD COURSES
    ========================================================= */

    const loadCourses = async () => {

        if (!hasMore)
            return;

        try {

            const response =
                await GetCourseList({
                    skip: skip.current,
                    take,
                });


            const newCourses =
                response?.data?.courses?.courseList ||
                [];


            const totalRecords =
                response?.data?.courses?.totalRecords ||
                0;


            setCoursesList(
                newCourses
            );


            if (
                skip.current + take >=
                totalRecords
            ) {

                setHasMore(false);
            }


            skip.current += take;

        } catch (error) {

            console.error(
                "Unable to load courses:",
                error
            );

            setHasMore(false);
        }
    };


    useEffect(() => {

        if (
            runOnceForLoad.current
        )
            return;

        loadCourses();

        runOnceForLoad.current = true;

    }, []);


    /* =========================================================
       HELPERS
    ========================================================= */

    const discountCourses = (
        coursePrice: number,
        discount: number
    ) => {

        const discounted =
            coursePrice -
            coursePrice *
            (discount / 100);

        return Math.round(
            discounted
        );
    };


    const getPackagePoster = (
        packageId: number
    ) => {

        return packagePoster.find(
            (data: any) =>
                data.packageId ===
                packageId
        )?.poster;
    };


    const getCoursePoster = (
        courseId: number
    ) => {

        return courseImage.find(
            (data: any) =>
                data.courseId ===
                courseId
        )?.posterLink;
    };


    const formatPrice = (
        value: any
    ) => {

        const number =
            Number(value) || 0;

        return new Intl.NumberFormat(
            "en-IN"
        ).format(number);
    };


    /* =========================================================
       PACKAGE DETAILS
    ========================================================= */

    const packageDetails = (
        pack: any
    ) => {

        if (!pack)
            return;

        setPackageDetailPage(
            pack
        );

        setTemplate(
            "packageDetail"
        );

        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    };


    /* =========================================================
       COUPON
    ========================================================= */

    const onCouponCodeChange = (
        event: React.ChangeEvent<HTMLInputElement>
    ) => {

        setInvalidCouponCode(false);

        setInputCouponCode(
            event.target.value
        );
    };


    const getUserNameByGID =
        async () => {

            if (
                !inputCouponCode.trim()
            ) {

                setInvalidCouponCode(
                    true
                );

                return;
            }

            setLoader(true);

            try {

                if (
                    inputCouponCode.trim() !==
                    "R1999"
                ) {

                    const response =
                        await getUserNameByGId(
                            inputCouponCode.trim(),
                            true
                        );


                    if (
                        response.success
                    ) {

                        setAddNewSponsorGrowniverseId(
                            response.data.userName
                        );

                        setCouponCode(
                            true
                        );

                        setShowCouponCode(
                            false
                        );

                        setInvalidCouponCode(
                            false
                        );


                        confetti({
                            particleCount: 150,
                            spread: 80,
                            origin: {
                                y: 0.6,
                            },
                            colors: [
                                "#00e5ff",
                                "#8b5cf6",
                                "#ffffff",
                                "#22c55e",
                            ],
                            shapes: [
                                "square",
                                "circle",
                            ],
                        });

                    } else {

                        setAddNewSponsorGrowniverseId(
                            ""
                        );

                        setCouponCode(
                            false
                        );

                        setInvalidCouponCode(
                            true
                        );
                    }

                } else {

                    setAddNewSponsorGrowniverseId(
                        ""
                    );

                    setCouponCode(
                        false
                    );

                    setInvalidCouponCode(
                        true
                    );
                }

            } catch (error) {

                console.error(
                    "Coupon validation error:",
                    error
                );

                setInvalidCouponCode(
                    true
                );

            } finally {

                setLoader(false);
            }
        };


    const removeCoupon = () => {

        setCouponCode(false);

        setAddNewSponsorGrowniverseId(
            ""
        );

        setInputCouponCode(
            ""
        );

        setInvalidCouponCode(
            false
        );
    };


    /* =========================================================
       FILTER COURSES
    ========================================================= */

    const filteredCourses =
        coursesList.filter(
            (course) =>
                course?.courseName
                    ?.toLowerCase()
                    .includes(
                        searchTerm.toLowerCase()
                    )
        );


    /* =========================================================
       CART
    ========================================================= */

    const isCourseInCart = (
        courseId: number
    ) => {

        return checkCountCourseList.some(
            (item) =>
                item.courseId ===
                courseId
        );
    };


    const addToCart = (
        course: any
    ) => {

        if (
            isCourseInCart(
                course.courseId
            )
        )
            return;

        setCheckoutCoursesList(
            (prev) => [
                ...prev,
                course,
            ]
        );
    };


    const removeFromCart = (
        courseId: number
    ) => {

        setCheckoutCoursesList(
            (prev) =>
                prev.filter(
                    (item) =>
                        item.courseId !==
                        courseId
                )
        );
    };


    /* =========================================================
       PACKAGE / COURSE SWITCH
    ========================================================= */

    const UpdateRecord = (
        showPackages?: boolean
    ) => {

        if (
            typeof showPackages ===
            "boolean"
        ) {

            setShowPackages(
                showPackages
            );

        } else {

            setShowPackages(
                !getShowPackages
            );
        }

        setTemplate(
            "package"
        );

        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    };


    /* =========================================================
       OPEN INTERNSHIP
    ========================================================= */

    const openInternship = () => {

        setTemplate(
            "internship"
        );

        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    };


    /* =========================================================
       BACK
    ========================================================= */

    const goToPackages = () => {

        setTemplate(
            "package"
        );

        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    };


    /* =========================================================
       RENDER
    ========================================================= */

    return (
        <>
            <style>{`

                * {
                    box-sizing: border-box;
                }

                .package-page {
                    position: relative;
                    min-height: 100vh;
                    width: 100%;
                    overflow-x: hidden;

                    color: #ffffff;

                    background:
                        radial-gradient(
                            circle at 20% 10%,
                            rgba(86, 73, 180, 0.12),
                            transparent 32%
                        ),
                        radial-gradient(
                            circle at 85% 30%,
                            rgba(0, 229, 255, 0.07),
                            transparent 30%
                        ),
                        #030305;
                }

                .package-bg {
                    position: fixed;
                    inset: 0;
                    z-index: 0;
                    pointer-events: none;
                    overflow: hidden;
                }

                .bg-grid {
                    position: absolute;
                    inset: 0;

                    background-image:
                        linear-gradient(
                            rgba(255,255,255,0.025) 1px,
                            transparent 1px
                        ),
                        linear-gradient(
                            90deg,
                            rgba(255,255,255,0.025) 1px,
                            transparent 1px
                        );

                    background-size: 55px 55px;

                    mask-image:
                        linear-gradient(
                            to bottom,
                            black,
                            transparent 85%
                        );
                }

                .bg-glow {
                    position: absolute;
                    border-radius: 50%;
                    filter: blur(120px);
                    opacity: 0.18;
                }

                .bg-glow-cyan {
                    width: 350px;
                    height: 350px;
                    background: #00e5ff;
                    top: 10%;
                    left: -150px;
                }

                .bg-glow-purple {
                    width: 400px;
                    height: 400px;
                    background: #7357ff;
                    top: 40%;
                    right: -180px;
                }

                .bg-glow-blue {
                    width: 300px;
                    height: 300px;
                    background: #246bff;
                    bottom: 0;
                    left: 35%;
                }

                .header-safe-space {
                    height: 80px;
                }

                .content-wrapper {
                    position: relative;
                    z-index: 2;

                    width: min(
                        calc(100% - 64px),
                        1440px
                    );

                    margin: 0 auto;

                    padding: 30px 0 80px;
                }

                .store-hero {
                    min-height: 280px;
                }

                .view-switch-wrapper {
                    display: flex;
                    justify-content: center;

                    margin:
                        34px 0 40px;
                }

                .view-switch {
                    display: inline-flex;

                    padding: 5px;

                    background:
                        rgba(255,255,255,0.045);

                    border:
                        1px solid
                        rgba(255,255,255,0.09);

                    border-radius: 15px;

                    backdrop-filter: blur(20px);
                }

                .switch-btn {
                    border: 0;
                    outline: 0;

                    padding: 11px 25px;

                    border-radius: 11px;

                    background: transparent;

                    color:
                        rgba(255,255,255,0.55);

                    font-size: 12px;
                    font-weight: 600;

                    letter-spacing: .4px;

                    cursor: pointer;

                    transition:
                        all .25s ease;
                }

                .switch-btn span {
                    margin-right: 7px;
                }

                .switch-btn.active {
                    color: #ffffff;

                    background:
                        linear-gradient(
                            135deg,
                            rgba(126,108,255,.32),
                            rgba(0,229,255,.12)
                        );
                }

                .products-section {
                    width: 100%;
                }

                .section-heading {
                    display: flex;

                    align-items: flex-end;
                    justify-content:
                        space-between;

                    gap: 30px;

                    margin-bottom: 26px;
                }

                .section-heading > div > span {
                    display: block;

                    margin-bottom: 7px;

                    color: #8176ff;

                    font-size: 9px;
                    font-weight: 700;

                    letter-spacing: 2px;
                }

                .section-heading h2 {
                    margin: 0;

                    font-size:
                        clamp(
                            25px,
                            3vw,
                            36px
                        );

                    line-height: 1.15;
                }

                .section-heading p {
                    max-width: 420px;

                    margin: 0;

                    color:
                        rgba(255,255,255,.42);

                    font-size: 13px;

                    line-height: 1.7;

                    text-align: right;
                }

                .course-search {
                    width: 100%;

                    height: 54px;

                    display: flex;
                    align-items: center;

                    padding: 0 17px;

                    margin-bottom: 30px;

                    border-radius: 15px;

                    background:
                        rgba(255,255,255,.035);

                    border:
                        1px solid
                        rgba(255,255,255,.08);
                }

                .course-search > span {
                    margin-right: 12px;

                    color:
                        rgba(255,255,255,.45);

                    font-size: 21px;
                }

                .course-search input {
                    flex: 1;
                    min-width: 0;

                    border: 0;
                    outline: 0;

                    background: transparent;

                    color: #ffffff;

                    font-size: 13px;
                }

                .course-search input::placeholder {
                    color:
                        rgba(255,255,255,.32);
                }

                .course-search button {
                    width: 28px;
                    height: 28px;

                    border: 0;
                    border-radius: 50%;

                    background:
                        rgba(255,255,255,.06);

                    color:
                        rgba(255,255,255,.6);

                    cursor: pointer;
                }

                .course-grid,
                .package-grid {
                    display: grid;

                    grid-template-columns:
                        repeat(
                            3,
                            minmax(0,1fr)
                        );

                    gap: 24px;
                }

                .product-card {
                    min-width: 0;

                    overflow: hidden;

                    border-radius: 20px;

                    background:
                        linear-gradient(
                            145deg,
                            rgba(255,255,255,.065),
                            rgba(255,255,255,.018)
                        );

                    border:
                        1px solid
                        rgba(255,255,255,.085);

                    transition:
                        transform .3s ease,
                        border-color .3s ease;
                }

                .product-card:hover {
                    transform:
                        translateY(-7px);

                    border-color:
                        rgba(130,116,255,.3);
                }

                .product-image {
                    position: relative;

                    width: 100%;

                    aspect-ratio:
                        16 / 9;

                    overflow: hidden;

                    background:
                        #08080d;
                }

                .product-image img {
                    width: 100%;
                    height: 100%;

                    display: block;

                    object-fit: cover;

                    transition:
                        transform .5s ease;
                }

                .product-card:hover
                .product-image img {
                    transform:
                        scale(1.045);
                }

                .product-image::after {
                    content: "";

                    position: absolute;

                    inset: 0;

                    background:
                        linear-gradient(
                            to bottom,
                            transparent 45%,
                            rgba(0,0,0,.72)
                        );
                }

                .product-badge {
                    position: absolute;

                    top: 14px;
                    left: 14px;

                    z-index: 2;

                    padding: 6px 9px;

                    border-radius: 7px;

                    background:
                        rgba(0,0,0,.65);

                    border:
                        1px solid
                        rgba(255,255,255,.14);

                    font-size: 8px;
                    font-weight: 700;

                    letter-spacing: 1.3px;
                }

                .image-bottom-label {
                    position: absolute;

                    left: 15px;
                    bottom: 13px;

                    z-index: 2;

                    color:
                        rgba(255,255,255,.7);

                    font-size: 8px;
                    font-weight: 700;

                    letter-spacing: 1.6px;
                }

                .product-body {
                    padding: 20px;
                }

                .card-top-row {
                    display: flex;

                    align-items: center;
                    justify-content:
                        space-between;

                    margin-bottom: 10px;
                }

                .card-type {
                    color: #8176ff;

                    font-size: 8px;
                    font-weight: 700;

                    letter-spacing: 1.5px;
                }

                .card-arrow {
                    color:
                        rgba(255,255,255,.35);

                    font-size: 17px;
                }

                .product-body h3 {
                    margin:
                        0 0 12px;

                    font-size: 18px;

                    line-height: 1.35;
                }

                .course-description {
                    display:
                        -webkit-box;

                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;

                    overflow: hidden;

                    min-height: 38px;

                    margin:
                        0 0 16px;

                    color:
                        rgba(255,255,255,.4);

                    font-size: 11px;

                    line-height: 1.7;
                }

                .price-panel {
                    padding: 14px;

                    margin-top: 15px;

                    border-radius: 13px;

                    background:
                        rgba(255,255,255,.035);

                    border:
                        1px solid
                        rgba(255,255,255,.055);
                }

                .price-caption {
                    display: block;

                    margin-bottom: 4px;

                    color:
                        rgba(255,255,255,.35);

                    font-size: 8px;

                    letter-spacing: 1.3px;
                }

                .current-price {
                    color: #ffffff;

                    font-size: 24px;
                    font-weight: 700;
                }

                .old-price {
                    margin-top: 3px;

                    color:
                        rgba(255,255,255,.32);

                    font-size: 10px;
                }

                .deal-label {
                    margin-bottom: 4px;

                    color: #55e6a5;

                    font-size: 8px;
                    font-weight: 700;

                    letter-spacing: 1.4px;
                }

                .price-row {
                    display: flex;

                    justify-content:
                        space-between;

                    gap: 10px;

                    margin-top: 4px;

                    color:
                        rgba(255,255,255,.3);

                    font-size: 9px;
                }

                .primary-action,
                .cart-action {
                    width: 100%;

                    min-height: 48px;

                    margin-top: 14px;

                    border-radius: 12px;

                    font-size: 10px;
                    font-weight: 700;

                    letter-spacing: .8px;

                    cursor: pointer;
                }

                .primary-action {
                    display: flex;

                    align-items: center;
                    justify-content:
                        space-between;

                    padding: 0 16px;

                    color: #ffffff;

                    border:
                        1px solid
                        rgba(126,108,255,.25);

                    background:
                        linear-gradient(
                            135deg,
                            rgba(126,108,255,.18),
                            rgba(0,229,255,.07)
                        );
                }

                .cart-action {
                    border:
                        1px solid
                        rgba(0,229,255,.16);

                    color: #ffffff;

                    background:
                        rgba(0,229,255,.055);
                }

                .cart-action.remove {
                    color: #55e6a5;

                    background:
                        rgba(85,230,165,.06);

                    border-color:
                        rgba(85,230,165,.18);
                }

                .empty-state {
                    grid-column:
                        1 / -1;

                    padding: 70px 20px;

                    text-align: center;

                    border-radius: 20px;

                    background:
                        rgba(255,255,255,.025);

                    border:
                        1px dashed
                        rgba(255,255,255,.1);
                }

                .empty-state > div {
                    margin-bottom: 12px;

                    color:
                        rgba(255,255,255,.3);

                    font-size: 38px;
                }

                .empty-state h3 {
                    margin:
                        0 0 7px;

                    font-size: 18px;
                }

                .empty-state p {
                    margin: 0;

                    color:
                        rgba(255,255,255,.35);

                    font-size: 11px;
                }

                .course-loader {
                    display: flex;

                    justify-content:
                        center;

                    padding: 40px 0;
                }

                .floating-cart {
                    position: fixed;

                    right: 28px;
                    bottom: 28px;

                    z-index: 1000;

                    min-width: 58px;
                    height: 58px;

                    display: flex;

                    align-items: center;
                    justify-content: center;

                    gap: 7px;

                    padding: 0 15px;

                    border-radius: 17px;

                    color: #ffffff;

                    background:
                        rgba(13,13,22,.88);

                    border:
                        1px solid
                        rgba(255,255,255,.13);

                    backdrop-filter:
                        blur(20px);

                    cursor: pointer;
                }

                .cart-label {
                    font-size: 9px;
                    font-weight: 700;

                    letter-spacing: 1px;
                }

                .close-icon {
                    font-size: 27px;
                }

                .coupon-status {
                    display: flex;

                    align-items: center;
                    justify-content:
                        space-between;

                    gap: 20px;

                    padding: 14px 18px;

                    margin-bottom: 30px;

                    border-radius: 15px;

                    background:
                        rgba(85,230,165,.045);

                    border:
                        1px solid
                        rgba(85,230,165,.13);
                }

                .coupon-status > div {
                    display: flex;

                    align-items: center;

                    gap: 12px;
                }

                .success-icon {
                    width: 34px;
                    height: 34px;

                    display: flex;

                    align-items: center;
                    justify-content: center;

                    border-radius: 10px;

                    color: #55e6a5;

                    background:
                        rgba(85,230,165,.08);
                }

                .coupon-status strong {
                    display: block;

                    margin-bottom: 3px;

                    font-size: 12px;
                }

                .coupon-status small {
                    color:
                        rgba(255,255,255,.38);

                    font-size: 9px;
                }

                .coupon-status button {
                    border: 0;

                    background:
                        transparent;

                    color:
                        rgba(255,255,255,.4);

                    font-size: 9px;

                    cursor: pointer;
                }

                .detail-page {
                    width: 100%;
                }

                .back-button {
                    display: inline-flex;

                    align-items: center;

                    gap: 9px;

                    margin-bottom: 28px;

                    padding: 10px 14px;

                    border-radius: 10px;

                    border:
                        1px solid
                        rgba(255,255,255,.08);

                    background:
                        rgba(255,255,255,.035);

                    color:
                        rgba(255,255,255,.7);

                    font-size: 10px;

                    cursor: pointer;
                }

                .detail-layout {
                    display: grid;

                    grid-template-columns:
                        minmax(0,1fr)
                        360px;

                    gap: 30px;
                }

                .detail-image {
                    position: relative;

                    width: 100%;

                    aspect-ratio:
                        16 / 8;

                    overflow: hidden;

                    border-radius: 22px;

                    border:
                        1px solid
                        rgba(255,255,255,.08);
                }

                .detail-image img {
                    width: 100%;
                    height: 100%;

                    object-fit: cover;
                }

                .detail-image-overlay {
                    position: absolute;

                    left: 20px;
                    bottom: 20px;

                    padding: 8px 11px;

                    border-radius: 8px;

                    background:
                        rgba(0,0,0,.55);

                    font-size: 9px;
                    font-weight: 700;
                }

                .detail-heading {
                    padding: 30px 5px;
                }

                .detail-heading > span {
                    color: #8176ff;

                    font-size: 9px;
                    font-weight: 700;

                    letter-spacing: 1.8px;
                }

                .detail-heading h1 {
                    margin:
                        9px 0;

                    font-size:
                        clamp(
                            28px,
                            4vw,
                            48px
                        );
                }

                .detail-heading p {
                    color:
                        rgba(255,255,255,.42);

                    font-size: 13px;

                    line-height: 1.8;
                }

                .detail-info,
                .share-section {
                    padding: 24px;

                    border-radius: 18px;

                    background:
                        rgba(255,255,255,.025);

                    border:
                        1px solid
                        rgba(255,255,255,.07);
                }

                .share-section {
                    margin-top: 24px;
                }

                .share-heading {
                    margin-bottom: 12px;

                    color:
                        rgba(255,255,255,.5);

                    font-size: 10px;
                }

                .purchase-panel {
                    position: sticky;

                    top: 100px;

                    padding: 25px;

                    border-radius: 20px;

                    background:
                        linear-gradient(
                            145deg,
                            rgba(255,255,255,.07),
                            rgba(255,255,255,.025)
                        );

                    border:
                        1px solid
                        rgba(255,255,255,.1);
                }

                .purchase-header {
                    display: flex;

                    justify-content:
                        space-between;

                    margin-bottom: 28px;

                    color:
                        rgba(255,255,255,.4);

                    font-size: 9px;
                    font-weight: 700;
                }

                .verified-pill {
                    padding: 5px 8px;

                    border-radius: 7px;

                    color: #55e6a5;

                    background:
                        rgba(85,230,165,.07);

                    font-size: 7px;
                }

                .purchase-caption {
                    color:
                        rgba(255,255,255,.35);

                    font-size: 8px;
                }

                .purchase-price {
                    margin-top: 5px;

                    font-size: 38px;
                    font-weight: 700;
                }

                .purchase-old-price {
                    color:
                        rgba(255,255,255,.32);

                    font-size: 11px;
                }

                .purchase-deal {
                    color: #55e6a5;

                    font-size: 8px;
                    font-weight: 700;
                }

                .purchase-benefits {
                    display: flex;

                    flex-direction: column;

                    gap: 12px;

                    margin-top: 28px;
                }

                .purchase-benefits div {
                    display: flex;

                    gap: 9px;

                    color:
                        rgba(255,255,255,.55);

                    font-size: 10px;
                }

                .purchase-benefits span {
                    color: #55e6a5;
                }

                .purchase-divider {
                    height: 1px;

                    margin: 25px 0;

                    background:
                        rgba(255,255,255,.07);
                }

                .purchase-button {
                    width: 100%;

                    min-height: 52px;

                    display: flex;

                    align-items: center;
                    justify-content:
                        space-between;

                    padding: 0 17px;

                    border:
                        1px solid
                        rgba(126,108,255,.3);

                    border-radius: 12px;

                    color: #ffffff;

                    background:
                        linear-gradient(
                            135deg,
                            rgba(126,108,255,.28),
                            rgba(0,229,255,.08)
                        );

                    font-size: 10px;
                    font-weight: 700;

                    cursor: pointer;
                }

                .secure-note {
                    display: flex;

                    justify-content: center;

                    gap: 6px;

                    margin-top: 13px;

                    color:
                        rgba(255,255,255,.3);

                    font-size: 8px;
                }

                .secure-note span {
                    color: #55e6a5;
                }

                .payment-page {
                    position: relative;

                    z-index: 2;

                    width: min(
                        calc(100% - 64px),
                        1000px
                    );

                    margin: 0 auto;

                    padding: 35px 0 80px;
                }

                .payment-header {
                    text-align: center;

                    margin:
                        25px auto 35px;
                }

                .payment-header > span {
                    color: #8176ff;

                    font-size: 9px;
                    font-weight: 700;

                    letter-spacing: 2px;
                }

                .payment-header h1 {
                    margin:
                        8px 0;

                    font-size:
                        clamp(
                            28px,
                            4vw,
                            42px
                        );
                }

                .payment-header p {
                    color:
                        rgba(255,255,255,.4);

                    font-size: 12px;
                }

                .payment-wrapper {
                    padding: 25px;

                    border-radius: 20px;

                    background:
                        rgba(255,255,255,.025);

                    border:
                        1px solid
                        rgba(255,255,255,.07);
                }

                .coupon-overlay {
                    position: fixed;

                    inset: 0;

                    z-index: 2000;

                    display: flex;

                    align-items: center;
                    justify-content: center;

                    padding: 20px;

                    background:
                        rgba(0,0,0,.72);

                    backdrop-filter:
                        blur(12px);
                }

                .coupon-modal {
                    position: relative;

                    width: min(
                        100%,
                        430px
                    );

                    padding: 32px;

                    border-radius: 22px;

                    background:
                        linear-gradient(
                            145deg,
                            #11111b,
                            #08080e
                        );

                    border:
                        1px solid
                        rgba(255,255,255,.1);
                }

                .coupon-close {
                    position: absolute;

                    top: 14px;
                    right: 14px;

                    width: 32px;
                    height: 32px;

                    border-radius: 50%;

                    border:
                        1px solid
                        rgba(255,255,255,.08);

                    background:
                        rgba(255,255,255,.04);

                    color:
                        rgba(255,255,255,.5);

                    cursor: pointer;
                }

                .coupon-icon {
                    font-size: 32px;

                    margin-bottom: 16px;
                }

                .coupon-title span {
                    color: #8176ff;

                    font-size: 8px;
                    font-weight: 700;

                    letter-spacing: 2px;
                }

                .coupon-title h2 {
                    margin:
                        7px 0;

                    font-size: 26px;
                }

                .coupon-title p {
                    margin:
                        0 0 22px;

                    color:
                        rgba(255,255,255,.4);

                    font-size: 11px;

                    line-height: 1.7;
                }

                .coupon-input {
                    width: 100%;

                    height: 50px;

                    padding: 0 15px;

                    border-radius: 11px;

                    outline: none;

                    background:
                        rgba(255,255,255,.04);

                    border:
                        1px solid
                        rgba(255,255,255,.1);

                    color: #ffffff;
                }

                .coupon-applied-box {
                    padding: 14px;

                    border-radius: 11px;

                    color: #55e6a5;

                    background:
                        rgba(85,230,165,.06);
                }

                .coupon-actions {
                    display: flex;

                    flex-direction: column;

                    gap: 9px;

                    margin-top: 18px;
                }

                .coupon-actions button {
                    width: 100%;

                    height: 46px;

                    border-radius: 10px;

                    font-size: 9px;
                    font-weight: 700;

                    cursor: pointer;
                }

                .coupon-apply {
                    color: #ffffff;

                    border:
                        1px solid
                        rgba(126,108,255,.3);

                    background:
                        linear-gradient(
                            135deg,
                            rgba(126,108,255,.25),
                            rgba(0,229,255,.08)
                        );
                }

                .coupon-remove {
                    color: #55e6a5;

                    background:
                        rgba(85,230,165,.07);

                    border:
                        1px solid
                        rgba(85,230,165,.18);
                }

                .coupon-cancel {
                    color:
                        rgba(255,255,255,.4);

                    background:
                        transparent;

                    border:
                        1px solid
                        rgba(255,255,255,.08);
                }


                @media (max-width: 1100px) {

                    .course-grid,
                    .package-grid {
                        grid-template-columns:
                            repeat(
                                2,
                                minmax(0,1fr)
                            );
                    }

                    .detail-layout {
                        grid-template-columns:
                            minmax(0,1fr)
                            320px;
                    }
                }


                @media (max-width: 800px) {

                    .content-wrapper {
                        width:
                            calc(100% - 40px);
                    }

                    .store-hero {
                        flex-direction:
                            column !important;

                        align-items:
                            flex-start !important;
                    }

                    .store-hero > div:last-child {
                        width: 100%;

                        min-width: 0 !important;
                    }

                    .section-heading {
                        flex-direction:
                            column;

                        align-items:
                            flex-start;
                    }

                    .section-heading p {
                        text-align:
                            left;
                    }

                    .detail-layout {
                        grid-template-columns:
                            1fr;
                    }

                    .purchase-panel {
                        position: relative;
                        top: auto;
                    }
                }


                @media (max-width: 600px) {

                    .header-safe-space {
                        height: 60px;
                    }

                    .content-wrapper {
                        width:
                            calc(100% - 28px);

                        padding:
                            18px 0 65px;
                    }

                    .payment-page {
                        width:
                            calc(100% - 28px);
                    }

                    .course-grid,
                    .package-grid {
                        grid-template-columns:
                            1fr;

                        gap: 18px;
                    }

                    .view-switch-wrapper {
                        margin:
                            25px 0 30px;
                    }

                    .switch-btn {
                        padding:
                            10px 12px;

                        font-size: 10px;
                    }

                    .switch-btn span {
                        margin-right: 4px;
                    }

                    .floating-cart {
                        right: 15px;
                        bottom: 15px;

                        height: 54px;
                        min-width: 54px;
                    }

                    .cart-label {
                        display: none;
                    }

                    .detail-info,
                    .share-section,
                    .purchase-panel,
                    .payment-wrapper {
                        padding: 18px;
                    }
                }

            `}</style>


            <div className="package-page">


                {/* =====================================================
                    BACKGROUND
                ===================================================== */}

                <div className="package-bg">

                    <div className="bg-grid" />

                    <div className="bg-glow bg-glow-cyan" />

                    <div className="bg-glow bg-glow-purple" />

                    <div className="bg-glow bg-glow-blue" />

                </div>


                <div className="header-safe-space" />


                {/* =====================================================
                    INTERNSHIP
                ===================================================== */}

                {template === "internship" && (

                    <InternshipPurchase
                        courses={coursesList}
                        onBack={() => {

                            setTemplate(
                                "package"
                            );

                            window.scrollTo({
                                top: 0,
                                behavior: "smooth",
                            });
                        }}
                    />

                )}


                {/* =====================================================
                    FLOATING CART
                ===================================================== */}

                {template !== "payment" &&
                    template !== "internship" && (

                        <button
                            className={
                                template === "cart"
                                    ? "floating-cart floating-close"
                                    : "floating-cart"
                            }
                            onClick={() => {

                                if (
                                    template === "cart"
                                ) {

                                    setTemplate(
                                        "package"
                                    );

                                } else {

                                    setTemplate(
                                        "cart"
                                    );
                                }

                            }}
                            aria-label="Shopping cart"
                        >

                            {template === "cart" ? (

                                <span className="close-icon">
                                    ×
                                </span>

                            ) : (

                                <CartIcon
                                    count={
                                        checkCountCourseList.length
                                    }
                                />

                            )}

                            {template !== "cart" && (

                                <span className="cart-label">
                                    CART
                                </span>

                            )}

                        </button>

                    )}


                {/* =====================================================
                    CART
                ===================================================== */}

                {template === "cart" && (

                    <main className="content-wrapper">

                        <div className="page-top-heading">

                            <div>

                                <span>
                                    YOUR SELECTION
                                </span>

                                <h1>
                                    Shopping Cart
                                </h1>

                                <p>
                                    Review your selected
                                    courses before checkout.
                                </p>

                            </div>

                        </div>


                        <CartModal
                            items={
                                checkCountCourseList
                            }
                            isDiscount={
                                couponCode
                            }
                            AddNewSponsorGrowniverseId={
                                addNewSponsorGrowniverseId
                            }
                        />

                    </main>

                )}


                {/* =====================================================
                    MAIN STORE
                ===================================================== */}

                {template !== "cart" &&
                    template !== "payment" &&
                    template !== "packageDetail" &&
                    template !== "internship" && (

                        <main className="content-wrapper">


                            {/* =================================================
                                HERO
                            ================================================= */}

                            <section
                                className="store-hero"
                                style={{
                                    position:
                                        "relative",

                                    overflow:
                                        "hidden",

                                    display:
                                        "flex",

                                    alignItems:
                                        "center",

                                    justifyContent:
                                        "space-between",

                                    gap: "30px",

                                    padding:
                                        "45px 6%",

                                    borderRadius:
                                        "24px",

                                    background:
                                        "radial-gradient(circle at 15% 50%, #5146d922, transparent 35%), radial-gradient(circle at 85% 20%, #00d9ff14, transparent 30%), linear-gradient(135deg,#050509,#0b0b16)",

                                    border:
                                        "1px solid #ffffff12",
                                }}
                            >

                                <div
                                    style={{
                                        zIndex: 2,
                                    }}
                                >

                                    <div
                                        style={{
                                            display:
                                                "inline-flex",

                                            alignItems:
                                                "center",

                                            gap: "8px",

                                            padding:
                                                "8px 13px",

                                            borderRadius:
                                                "30px",

                                            background:
                                                "#ffffff08",

                                            border:
                                                "1px solid #ffffff12",

                                            color:
                                                "#aaa6c9",

                                            fontSize:
                                                "10px",

                                            letterSpacing:
                                                "1.5px",
                                        }}
                                    >

                                        <span
                                            style={{
                                                width: "6px",
                                                height: "6px",
                                                borderRadius:
                                                    "50%",
                                                background:
                                                    "#8b7cff",
                                                boxShadow:
                                                    "0 0 12px #8b7cff",
                                            }}
                                        />

                                        GROWNIVERSE /
                                        DIGITAL ACADEMY

                                    </div>


                                    <p
                                        style={{
                                            maxWidth:
                                                "520px",

                                            margin:
                                                "22px 0 0",

                                            color:
                                                "#ffffff88",

                                            lineHeight:
                                                "1.7",

                                            fontSize:
                                                "15px",
                                        }}
                                    >

                                        Learn from premium
                                        courses and carefully
                                        curated learning packages
                                        designed to help you grow,
                                        build and achieve more.

                                    </p>


                                    <div
                                        style={{
                                            display:
                                                "flex",

                                            gap: "28px",

                                            marginTop:
                                                "30px",
                                        }}
                                    >

                                        {[
                                            [
                                                coursesList.length +
                                                "+",
                                                "COURSES",
                                            ],
                                            [
                                                packages.length +
                                                "+",
                                                "PACKAGES",
                                            ],
                                            [
                                                "24/7",
                                                "LEARNING",
                                            ],
                                        ].map(
                                            ([value, label], i) => (

                                                <div
                                                    key={
                                                        label
                                                    }
                                                    style={{
                                                        paddingRight:
                                                            i < 2
                                                                ? "25px"
                                                                : 0,

                                                        borderRight:
                                                            i < 2
                                                                ? "1px solid #ffffff18"
                                                                : "none",
                                                    }}
                                                >

                                                    <strong
                                                        style={{
                                                            display:
                                                                "block",

                                                            color:
                                                                "#fff",

                                                            fontSize:
                                                                "24px",
                                                        }}
                                                    >
                                                        {value}
                                                    </strong>

                                                    <span
                                                        style={{
                                                            color:
                                                                "#ffffff55",

                                                            fontSize:
                                                                "9px",

                                                            letterSpacing:
                                                                "1.5px",
                                                        }}
                                                    >
                                                        {label}
                                                    </span>

                                                </div>

                                            )
                                        )}

                                    </div>

                                </div>


                                {/* =================================================
                                    COUPON
                                ================================================= */}

                                {couponCode ? (

                                    <div
                                        style={{
                                            minWidth:
                                                "290px",

                                            padding:
                                                "16px 18px",

                                            display:
                                                "flex",

                                            alignItems:
                                                "center",

                                            gap: "14px",

                                            background:
                                                "linear-gradient(135deg,rgba(70,220,150,.10),rgba(255,255,255,.035))",

                                            border:
                                                "1px solid rgba(70,220,150,.25)",

                                            borderRadius:
                                                "18px",
                                        }}
                                    >

                                        <div
                                            style={{
                                                width:
                                                    "42px",

                                                height:
                                                    "42px",

                                                display:
                                                    "flex",

                                                alignItems:
                                                    "center",

                                                justifyContent:
                                                    "center",

                                                borderRadius:
                                                    "13px",

                                                color:
                                                    "#55e6a5",

                                                fontSize:
                                                    "20px",

                                                background:
                                                    "rgba(85,230,165,.10)",
                                            }}
                                        >
                                            ✓
                                        </div>


                                        <div
                                            style={{
                                                flex: 1,
                                            }}
                                        >

                                            <small
                                                style={{
                                                    display:
                                                        "block",

                                                    color:
                                                        "#55e6a5",

                                                    fontSize:
                                                        "8px",

                                                    fontWeight:
                                                        700,

                                                    letterSpacing:
                                                        "1.5px",
                                                }}
                                            >
                                                SPONSOR VERIFIED
                                            </small>

                                            <strong
                                                style={{
                                                    display:
                                                        "block",

                                                    color:
                                                        "#fff",

                                                    fontSize:
                                                        "13px",

                                                    margin:
                                                        "4px 0",
                                                }}
                                            >
                                                Special pricing activated
                                            </strong>

                                            <small
                                                style={{
                                                    color:
                                                        "#ffffff66",

                                                    fontSize:
                                                        "10px",
                                                }}
                                            >
                                                Your sponsor discount
                                                is applied.
                                            </small>

                                        </div>


                                        <button
                                            onClick={
                                                removeCoupon
                                            }
                                            style={{
                                                width:
                                                    "32px",

                                                height:
                                                    "32px",

                                                borderRadius:
                                                    "50%",

                                                border:
                                                    "1px solid rgba(255,255,255,.10)",

                                                background:
                                                    "rgba(255,255,255,.04)",

                                                color:
                                                    "#ffffff66",

                                                cursor:
                                                    "pointer",
                                            }}
                                        >
                                            ✕
                                        </button>

                                    </div>

                                ) : (

                                    <button
                                        onClick={() =>
                                            setShowCouponCode(
                                                true
                                            )
                                        }
                                        style={{
                                            zIndex: 2,

                                            display:
                                                "flex",

                                            alignItems:
                                                "center",

                                            gap: "14px",

                                            padding:
                                                "17px",

                                            minWidth:
                                                "290px",

                                            color:
                                                "#fff",

                                            textAlign:
                                                "left",

                                            background:
                                                "linear-gradient(135deg,rgba(255,255,255,.07),rgba(255,255,255,.025))",

                                            border:
                                                "1px solid rgba(255,255,255,.12)",

                                            borderRadius:
                                                "18px",

                                            cursor:
                                                "pointer",
                                        }}
                                    >

                                        <span
                                            style={{
                                                fontSize:
                                                    "22px",
                                            }}
                                        >
                                            🎟
                                        </span>


                                        <span
                                            style={{
                                                flex: 1,
                                            }}
                                        >

                                            <small
                                                style={{
                                                    display:
                                                        "block",

                                                    color:
                                                        "#887bff",

                                                    fontSize:
                                                        "8px",

                                                    letterSpacing:
                                                        "1.5px",
                                                }}
                                            >
                                                SPECIAL ACCESS
                                            </small>

                                            <strong
                                                style={{
                                                    display:
                                                        "block",

                                                    margin:
                                                        "3px 0",

                                                    fontSize:
                                                        "13px",
                                                }}
                                            >
                                                Have a sponsor code?
                                            </strong>

                                            <small
                                                style={{
                                                    color:
                                                        "#ffffff55",

                                                    fontSize:
                                                        "10px",
                                                }}
                                            >
                                                Unlock exclusive pricing
                                            </small>

                                        </span>


                                        <span
                                            style={{
                                                fontSize:
                                                    "20px",
                                            }}
                                        >
                                            →
                                        </span>

                                    </button>

                                )}

                            </section>


                            {/* =================================================
                                SWITCH
                            ================================================= */}

                            <div className="view-switch-wrapper">

                                <div className="view-switch">


                                    <button
                                        className={
                                            !getShowPackages
                                                ? "switch-btn active"
                                                : "switch-btn"
                                        }
                                        onClick={() =>
                                            UpdateRecord(
                                                false
                                            )
                                        }
                                    >

                                        <span>
                                            🎓
                                        </span>

                                        Courses

                                    </button>


                                    <button
                                        className={
                                            getShowPackages
                                                ? "switch-btn active"
                                                : "switch-btn"
                                        }
                                        onClick={() =>
                                            UpdateRecord(
                                                true
                                            )
                                        }
                                    >

                                        <span>
                                            ◈
                                        </span>

                                        Packages

                                    </button>


                                    {/* =============================
                                        INTERNSHIP
                                    ============================= */}

                                    <button
                                        className="switch-btn"
                                        onClick={
                                            openInternship
                                        }
                                    >

                                        <span>
                                            ✦
                                        </span>

                                        Internship

                                    </button>


                                </div>

                            </div>


                            {/* =================================================
                                COUPON STATUS
                            ================================================= */}

                            {couponCode && (

                                <div
                                    className="coupon-status"
                                >

                                    <div>

                                        <span
                                            className="success-icon"
                                        >
                                            ✓
                                        </span>

                                        <div>

                                            <strong>
                                                Special pricing activated
                                            </strong>

                                            <small>
                                                Your sponsor discount
                                                is now applied.
                                            </small>

                                        </div>

                                    </div>


                                    <button
                                        onClick={
                                            removeCoupon
                                        }
                                    >
                                        Remove Coupon
                                    </button>

                                </div>

                            )}


                            {/* =================================================
                                PACKAGES / COURSES
                            ================================================= */}

                            {getShowPackages ? (

                                <section
                                    className="products-section"
                                >

                                    <div
                                        className="section-heading"
                                    >

                                        <div>

                                            <span>
                                                PREMIUM COLLECTION
                                            </span>

                                            <h2>
                                                Learning Packages
                                            </h2>

                                        </div>

                                        <p>
                                            Complete learning experiences
                                            built for serious growth.
                                        </p>

                                    </div>


                                    <div
                                        className="package-grid"
                                    >

                                        {packages.length ===
                                        0 ? (

                                            <div
                                                className="empty-state"
                                            >

                                                <div>
                                                    ◇
                                                </div>

                                                <h3>
                                                    Packages Coming Soon
                                                </h3>

                                                <p>
                                                    New learning experiences
                                                    are being prepared.
                                                </p>

                                            </div>

                                        ) : (

                                            packages.map(
                                                (
                                                    pack,
                                                    index
                                                ) => (

                                                    <article
                                                        className="product-card"
                                                        key={
                                                            pack.packageId ||
                                                            index
                                                        }
                                                    >

                                                        <div
                                                            className="product-image"
                                                        >

                                                            <img
                                                                src={
                                                                    getPackagePoster(
                                                                        pack.packageId
                                                                    )
                                                                }
                                                                alt={
                                                                    pack.packageName
                                                                }
                                                            />

                                                            <span
                                                                className="product-badge"
                                                            >
                                                                PACKAGE
                                                            </span>

                                                            <div
                                                                className="image-bottom-label"
                                                            >
                                                                PREMIUM LEARNING
                                                            </div>

                                                        </div>


                                                        <div
                                                            className="product-body"
                                                        >

                                                            <div
                                                                className="card-top-row"
                                                            >

                                                                <span
                                                                    className="card-type"
                                                                >
                                                                    CURATED
                                                                </span>

                                                                <span
                                                                    className="card-arrow"
                                                                >
                                                                    ↗
                                                                </span>

                                                            </div>


                                                            <h3>
                                                                {
                                                                    pack.packageName
                                                                }
                                                            </h3>


                                                            <div
                                                                className="price-panel"
                                                            >

                                                                {!couponCode ? (

                                                                    <>
                                                                        <span
                                                                            className="price-caption"
                                                                        >
                                                                            PACKAGE PRICE
                                                                        </span>

                                                                        <div
                                                                            className="current-price"
                                                                        >
                                                                            ₹
                                                                            {
                                                                                formatPrice(
                                                                                    pack.discountedPrice
                                                                                )
                                                                            }
                                                                        </div>

                                                                        <div
                                                                            className="old-price"
                                                                        >
                                                                            MRP ₹
                                                                            {
                                                                                formatPrice(
                                                                                    pack.packagePrice
                                                                                )
                                                                            }
                                                                        </div>
                                                                    </>

                                                                ) : (

                                                                    <>
                                                                        <div
                                                                            className="deal-label"
                                                                        >
                                                                            SAVE{" "}
                                                                            {
                                                                                discountOnPackage
                                                                            }%
                                                                        </div>

                                                                        <div
                                                                            className="current-price"
                                                                        >
                                                                            ₹
                                                                            {
                                                                                formatPrice(
                                                                                    discountCourses(
                                                                                        pack.discountedPrice,
                                                                                        discountOnPackage
                                                                                    )
                                                                                )
                                                                            }
                                                                        </div>

                                                                        <div
                                                                            className="price-row"
                                                                        >
                                                                            <span>
                                                                                Previous ₹
                                                                                {
                                                                                    formatPrice(
                                                                                        pack.discountedPrice
                                                                                    )
                                                                                }
                                                                            </span>

                                                                            <span>
                                                                                Sponsor Offer
                                                                            </span>
                                                                        </div>
                                                                    </>

                                                                )}

                                                            </div>


                                                            <button
                                                                className="primary-action"
                                                                onClick={() =>
                                                                    packageDetails(
                                                                        pack
                                                                    )
                                                                }
                                                            >

                                                                <span>
                                                                    EXPLORE PACKAGE
                                                                </span>

                                                                <b>
                                                                    →
                                                                </b>

                                                            </button>

                                                        </div>

                                                    </article>

                                                )
                                            )

                                        )}

                                    </div>

                                </section>

                            ) : (

                                <section
                                    className="products-section"
                                >

                                    <div
                                        className="section-heading"
                                    >

                                        <div>

                                            <span>
                                                LEARNING LIBRARY
                                            </span>

                                            <h2>
                                                Explore Courses
                                            </h2>

                                        </div>

                                        <p>
                                            Choose individual courses
                                            and build your own
                                            learning path.
                                        </p>

                                    </div>


                                    {/* SEARCH */}

                                    <div
                                        className="course-search"
                                    >

                                        <span>
                                            ⌕
                                        </span>

                                        <input
                                            type="text"
                                            placeholder="Search courses..."
                                            value={
                                                searchTerm
                                            }
                                            onChange={(
                                                e
                                            ) =>
                                                setSearchTerm(
                                                    e.target.value
                                                )
                                            }
                                        />

                                        {searchTerm && (

                                            <button
                                                onClick={() =>
                                                    setSearchTerm(
                                                        ""
                                                    )
                                                }
                                            >
                                                ×
                                            </button>

                                        )}

                                    </div>


                                    {/* COURSES */}

                                    <div
                                        className="course-grid"
                                    >

                                        {filteredCourses.length ===
                                        0 ? (

                                            <div
                                                className="empty-state"
                                            >

                                                <div>
                                                    ⌕
                                                </div>

                                                <h3>
                                                    No Courses Found
                                                </h3>

                                                <p>
                                                    Try another search term.
                                                </p>

                                            </div>

                                        ) : (

                                            filteredCourses.map(
                                                (
                                                    course
                                                ) => (

                                                    <article
                                                        className="product-card"
                                                        key={
                                                            course.CourseId ||
                                                            course.courseId
                                                        }
                                                    >

                                                        <div
                                                            className="product-image"
                                                        >

                                                            <img
                                                                src={
                                                                    getCoursePoster(
                                                                        course.courseId
                                                                    )
                                                                }
                                                                alt={
                                                                    course.courseName
                                                                }
                                                            />

                                                            <span
                                                                className="product-badge"
                                                            >
                                                                COURSE
                                                            </span>

                                                            <div
                                                                className="image-bottom-label"
                                                            >
                                                                DIGITAL LEARNING
                                                            </div>

                                                        </div>


                                                        <div
                                                            className="product-body"
                                                        >

                                                            <div
                                                                className="card-top-row"
                                                            >

                                                                <span
                                                                    className="card-type"
                                                                >
                                                                    COURSE
                                                                </span>

                                                                <span
                                                                    className="card-arrow"
                                                                >
                                                                    ↗
                                                                </span>

                                                            </div>


                                                            <h3>
                                                                {
                                                                    course.courseName
                                                                }
                                                            </h3>


                                                            <p
                                                                className="course-description"
                                                            >
                                                                {
                                                                    course.courseDescription
                                                                }
                                                            </p>


                                                            <div
                                                                className="price-panel"
                                                            >

                                                                {!couponCode ? (

                                                                    <>
                                                                        <span
                                                                            className="price-caption"
                                                                        >
                                                                            COURSE PRICE
                                                                        </span>

                                                                        <div
                                                                            className="current-price"
                                                                        >
                                                                            ₹
                                                                            {
                                                                                formatPrice(
                                                                                    course.coursePrice
                                                                                )
                                                                            }
                                                                        </div>
                                                                    </>

                                                                ) : (

                                                                    <>
                                                                        <div
                                                                            className="deal-label"
                                                                        >
                                                                            SAVE{" "}
                                                                            {
                                                                                discountOnCourses
                                                                            }%
                                                                        </div>

                                                                        <div
                                                                            className="current-price"
                                                                        >
                                                                            ₹
                                                                            {
                                                                                formatPrice(
                                                                                    discountCourses(
                                                                                        course.coursePrice,
                                                                                        discountOnCourses
                                                                                    )
                                                                                )
                                                                            }
                                                                        </div>

                                                                        <div
                                                                            className="old-price"
                                                                        >
                                                                            ₹
                                                                            {
                                                                                formatPrice(
                                                                                    course.coursePrice
                                                                                )
                                                                            }
                                                                        </div>
                                                                    </>

                                                                )}

                                                            </div>


                                                            {isCourseInCart(
                                                                course.courseId
                                                            ) ? (

                                                                <button
                                                                    className="cart-action remove"
                                                                    onClick={() =>
                                                                        removeFromCart(
                                                                            course.courseId
                                                                        )
                                                                    }
                                                                >

                                                                    ✓
                                                                    &nbsp;
                                                                    REMOVE FROM CART

                                                                </button>

                                                            ) : (

                                                                <button
                                                                    className="cart-action"
                                                                    onClick={() =>
                                                                        addToCart(
                                                                            course
                                                                        )
                                                                    }
                                                                >

                                                                    +
                                                                    &nbsp;
                                                                    ADD TO CART

                                                                </button>

                                                            )}

                                                        </div>

                                                    </article>

                                                )
                                            )

                                        )}

                                    </div>


                                    {hasMore && (

                                        <div
                                            ref={
                                                listloader
                                            }
                                            className="course-loader"
                                        >

                                            <ClipLoader
                                                color="#00e5ff"
                                                size={35}
                                            />

                                        </div>

                                    )}

                                </section>

                            )}

                        </main>

                    )}


                {/* =====================================================
                    PACKAGE DETAIL
                ===================================================== */}

                {template ===
                    "packageDetail" && (

                    <main
                        className="content-wrapper"
                    >

                        <section
                            className="detail-page"
                        >

                            <button
                                className="back-button"
                                onClick={
                                    goToPackages
                                }
                            >
                                ←
                                <span>
                                    Back to Packages
                                </span>
                            </button>


                            <div
                                className="detail-layout"
                            >

                                <div
                                    className="detail-main"
                                >

                                    <div
                                        className="detail-image"
                                    >

                                        <img
                                            src={
                                                getPackagePoster(
                                                    packageDetailData.packageId
                                                )
                                            }
                                            alt={
                                                packageDetailData.packageName
                                            }
                                        />

                                        <div
                                            className="detail-image-overlay"
                                        >
                                            PREMIUM PACKAGE
                                        </div>

                                    </div>


                                    <div
                                        className="detail-heading"
                                    >

                                        <span>
                                            PREMIUM LEARNING EXPERIENCE
                                        </span>

                                        <h1>
                                            {
                                                packageDetailData.packageName
                                            }
                                        </h1>

                                        <p>
                                            Invest in structured
                                            learning designed to
                                            help you move forward
                                            with confidence.
                                        </p>

                                    </div>


                                    <div
                                        className="detail-info"
                                    >

                                        <CourseInfoWidget
                                            packageId={
                                                packageDetailData.packageId
                                            }
                                        />

                                    </div>


                                    <div
                                        className="share-section"
                                    >

                                        <div
                                            className="share-heading"
                                        >
                                            Share this package
                                        </div>

                                        <SocialShareWidget />

                                    </div>

                                </div>


                                <aside
                                    className="purchase-panel"
                                >

                                    <div
                                        className="purchase-header"
                                    >

                                        <span>
                                            PACKAGE ACCESS
                                        </span>

                                        <div
                                            className="verified-pill"
                                        >
                                            ✓ VERIFIED
                                        </div>

                                    </div>


                                    {!couponCode ? (

                                        <>
                                            <div
                                                className="purchase-caption"
                                            >
                                                ONE-TIME INVESTMENT
                                            </div>

                                            <div
                                                className="purchase-price"
                                            >
                                                ₹
                                                {
                                                    formatPrice(
                                                        packageDetailData.discountedPrice
                                                    )
                                                }
                                            </div>

                                            <div
                                                className="purchase-old-price"
                                            >
                                                MRP ₹
                                                {
                                                    formatPrice(
                                                        packageDetailData.packagePrice
                                                    )
                                                }
                                            </div>
                                        </>

                                    ) : (

                                        <>
                                            <div
                                                className="purchase-deal"
                                            >
                                                SPONSOR DISCOUNT APPLIED
                                            </div>

                                            <div
                                                className="purchase-price"
                                            >
                                                ₹
                                                {
                                                    formatPrice(
                                                        discountCourses(
                                                            packageDetailData.discountedPrice,
                                                            discountOnPackage
                                                        )
                                                    )
                                                }
                                            </div>

                                            <div
                                                className="purchase-old-price"
                                            >
                                                ₹
                                                {
                                                    formatPrice(
                                                        packageDetailData.discountedPrice
                                                    )
                                                }
                                            </div>
                                        </>

                                    )}


                                    <div
                                        className="purchase-benefits"
                                    >

                                        <div>
                                            <span>✓</span>
                                            Premium course access
                                        </div>

                                        <div>
                                            <span>✓</span>
                                            Structured learning
                                        </div>

                                        <div>
                                            <span>✓</span>
                                            Secure checkout
                                        </div>

                                    </div>


                                    <div
                                        className="purchase-divider"
                                    />


                                    <button
                                        className="purchase-button"
                                        onClick={() =>
                                            setTemplate(
                                                "payment"
                                            )
                                        }
                                    >

                                        GET THIS PACKAGE

                                        <span>
                                            →
                                        </span>

                                    </button>


                                    <div
                                        className="secure-note"
                                    >
                                        <span>✓</span>
                                        Secure payment &
                                        learning access
                                    </div>

                                </aside>

                            </div>

                        </section>

                    </main>

                )}


                {/* =====================================================
                    PAYMENT
                ===================================================== */}

                {template ===
                    "payment" && (

                    <main
                        className="payment-page"
                    >

                        <button
                            className="back-button"
                            onClick={() =>
                                setTemplate(
                                    "packageDetail"
                                )
                            }
                        >
                            ←
                            <span>
                                Back to package
                            </span>
                        </button>


                        <div
                            className="payment-header"
                        >

                            <span>
                                SECURE CHECKOUT
                            </span>

                            <h1>
                                Complete Your Purchase
                            </h1>

                            <p>
                                You're one step away
                                from accessing your
                                learning package.
                            </p>

                        </div>


                        <div
                            className="payment-wrapper"
                        >

                            <Payment
                                packageId={
                                    packageDetailData.packageId
                                }

                                packageName={
                                    packageDetailData.packageName
                                }

                                price={
                                    couponCode
                                        ? discountCourses(
                                            packageDetailData.discountedPrice,
                                            discountOnPackage
                                        )
                                        : packageDetailData.discountedPrice
                                }

                                IsUpgrade={false}

                                CouponCode={
                                    couponCode
                                }

                                AddNewSponsorGrowniverseId={
                                    addNewSponsorGrowniverseId
                                }
                            />

                        </div>

                    </main>

                )}


                {/* =====================================================
                    COUPON MODAL
                ===================================================== */}

                {showCouponCode && (

                    <div
                        className="coupon-overlay"
                        onMouseDown={(
                            e
                        ) => {

                            if (
                                e.target ===
                                e.currentTarget
                            ) {

                                setShowCouponCode(
                                    false
                                );
                            }

                        }}
                    >

                        {loader ? (

                            <UserLoaderBlankBackground />

                        ) : (

                            <div
                                className="coupon-modal"
                            >

                                <button
                                    className="coupon-close"
                                    onClick={() =>
                                        setShowCouponCode(
                                            false
                                        )
                                    }
                                >
                                    ×
                                </button>


                                <div
                                    className="coupon-icon"
                                >
                                    🎟
                                </div>


                                <div
                                    className="coupon-title"
                                >

                                    <span>
                                        SPECIAL OFFER
                                    </span>

                                    <h2>
                                        Unlock Your Offer
                                    </h2>

                                    <p>
                                        Enter your sponsor
                                        code to unlock
                                        exclusive learning
                                        prices.
                                    </p>

                                </div>


                                {!couponCode ? (

                                    <input
                                        className="coupon-input"
                                        type="text"
                                        placeholder="Enter sponsor code"
                                        value={
                                            inputCouponCode
                                        }
                                        onChange={
                                            onCouponCodeChange
                                        }
                                        autoFocus
                                    />

                                ) : (

                                    <div
                                        className="coupon-applied-box"
                                    >
                                        ✓ Coupon applied
                                        successfully
                                    </div>

                                )}


                                {invalidCouponCode && (

                                    <Alert
                                        severity="error"
                                        sx={{
                                            width:
                                                "100%",
                                            mb: 2,
                                            boxSizing:
                                                "border-box",
                                        }}
                                    >
                                        Invalid Coupon Code
                                    </Alert>

                                )}


                                <div
                                    className="coupon-actions"
                                >

                                    {!couponCode ? (

                                        <button
                                            className="coupon-apply"
                                            onClick={
                                                getUserNameByGID
                                            }
                                        >
                                            APPLY COUPON
                                        </button>

                                    ) : (

                                        <button
                                            className="coupon-remove"
                                            onClick={
                                                removeCoupon
                                            }
                                        >
                                            REMOVE COUPON
                                        </button>

                                    )}


                                    <button
                                        className="coupon-cancel"
                                        onClick={() =>
                                            setShowCouponCode(
                                                false
                                            )
                                        }
                                    >
                                        CANCEL
                                    </button>

                                </div>

                            </div>

                        )}

                    </div>

                )}

            </div>
        </>
    );
};


export default Package;